module.exports = __webpack_public_path__ + "static/media/Interactions.cca90de0.png";